import Company from "../../admin/models/Company";
import Country from "../../admin/models/Country";
import TransactionCompany from "./TransactionCompany";
class TransactionCompanyWrapper extends TransactionCompany {
    company;
    country;
    ultimateParent;
    constructor(response) {
        super(response);
        this.company = response?.company !== undefined ? new Company(response.company) : undefined;
        this.country = response?.country !== undefined ? new Country(response.country) : undefined;
        this.ultimateParent = response?.ultimateParent !== undefined ? new Company(response.ultimateParent) : undefined;
    }
    toResponse() {
        return {
            company: this.company?.toResponse(),
            companyId: this.companyId,
            country: this.country?.toResponse(),
            name: this.name,
            type: this.type,
            ultimateParent: this.ultimateParent?.toResponse()
        };
    }
    transactionCompanyOnly() {
        return new TransactionCompanyWrapper({
            companyId: this.companyId,
            name: this.name,
            type: this.type
        });
    }
}
export default TransactionCompanyWrapper;
